import { CssBaseline, ThemeProvider } from '@mui/material';
import { MuiToastContainer, i18n, theme } from '@vxui/components';
import '@vxui/components/fonts/Montserrat.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import translationsEn from './resources/en.json';
import { routes } from './routes';
import { store } from './store/store';

const router = createBrowserRouter(routes, { basename: import.meta.env.BASE_URL });

i18n.addResourceBundle('en', 'sencoreCalc', translationsEn, true, true);
i18n.setDefaultNamespace('sencoreCalc');

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline>
          <I18nextProvider i18n={i18n}>
            <RouterProvider router={router} />
            <MuiToastContainer limit={5} />
          </I18nextProvider>
        </CssBaseline>
      </ThemeProvider>
    </Provider>
  </StrictMode>,
);
